module.exports = __webpack_public_path__ + "img/d20190322_4.fb5136c9.jpg";